export function getMutationErrorMessage(
  error: unknown,
  fallbackMessage: string = 'Could not delete this capsule.',
): string {
  if (!error || typeof error !== 'object') return fallbackMessage;
  if (!('data' in error)) return fallbackMessage;

  const data = (error as { data?: { message?: string } }).data;
  const message = data?.message;
  if (typeof message === 'string' && message.length > 0) {
    return message;
  }

  return fallbackMessage;
}
